import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-cash",
  "use": "icon-cash-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-cash\"><path d=\"M794.752 137.365333L733.696 198.4A382.250667 382.250667 0 0 0 512 128C299.925333 128 128 299.925333 128 512s171.925333 384 384 384 384-171.925333 384-384c0-83.285333-26.517333-160.384-71.573333-223.317333l61.013333-61.013334A467.285333 467.285333 0 0 1 981.333333 512c0 259.2-210.133333 469.333333-469.333333 469.333333S42.666667 771.2 42.666667 512 252.8 42.666667 512 42.666667c106.176 0 204.117333 35.264 282.752 94.698666zM512 270.634667L753.365333 512 512 753.365333 270.634667 512 512 270.634667z m0 120.682666L391.317333 512 512 632.682667 632.682667 512 512 391.317333z\" p-id=\"40358\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/cash.svg
// module id = SV64
// module chunks = 117